import React, { Component } from 'react';
import Calendar32 from '@carbon/icons-react/lib/calendar/32';
import Thumbnail32 from '@carbon/icons-react/lib/thumbnail--2/32';
import Task32 from '@carbon/icons-react/lib/task/32';
import Help32 from '@carbon/icons-react/lib/help/32';
import { Link, } from 'react-router-dom'
import MeRepository from '../helpers/api/MeRepository'; //RITM0945943
import { Loading } from "carbon-components-react"; //RITM0945943

export class Home extends Component {
    static displayName = Home.name;
    //RITM0945943
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            userMessage: null,
        };
        this.getUserMessage = this.getUserMessage.bind(this);
    }

    componentDidMount() {
        this.getUserMessage();
    }
    getUserMessage = async () => {
        try {
            this.setState({ loading: true });
            const message = await MeRepository.getUserMessage();
            this.setState({ userMessage: message, loading: false });
        } catch (error) {
          console.error(error);
        }
      };
    //End

    render() {
        let loading = this.state.loading; //RITM0945943
        return (
            <>
            {/* RITM0945943 */}
            {loading && <Loading active={true} withOverlay={true} description="Loading data..." />} 
            <div className="bx--grid max-width">
                <div className="bx--row row-eq-height">
                    <div className="bx--row row-tasks">
                        <Link to={`/dailytasks`}>
                            <div className="heading-container">
                                <Task32 />
                                <h1 className="heading">Daily Tasks</h1>
                                <h1 className="subheading">My pending daily activities</h1>
                            </div>
                        </Link>
                    </div>
                    <div className="bx--row row-functions">
                        {/* RITM0945943 */}
                        <>
                            {this.state.userMessage != null && this.state.userMessage?.message != null ?
                                (
                                    <div className='homepagemessage'>
                                        <span style={{ paddingRight: '10px', 
                                            }}><img src="/images/warning-icon.png" /></span>
                                       {this.state.userMessage.message}
                                    </div>
                                )
                                : (
                                    ''
                             )}
                        </>
                        {/* End */}
                        <Link to={`/modules`}>
                            <div className="heading-container">
                                <Thumbnail32 />
                                <h1 className="heading">Modules</h1>
                                <h1 className="subheading">Incident, Audit, Report, HOC, Inspection Management, Emergency Drill, Training, Insight Data, Group Dashboard</h1> 
                            </div>
                        </Link>
                    </div>
                    <div className="bx--row row-utilities">
                        <Link to={`/support`}>
                            <div className="heading-container">
                                <Help32 />
                                <h1 className="heading">Support</h1>
                                <h1 className="subheading">Do you need help?</h1>
                            </div>
                        </Link>
                    </div>
                </div>

            </div>
            {/* RITM0945943 */}
            </>
        );
    }
}
